import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "knowledges custom-scroll"
};
const _hoisted_2 = {
  class: "flex justify-between h-20"
};
const _hoisted_3 = {
  class: "scrollbar-type-nav"
};
const _hoisted_4 = {
  class: "flex items-center gap-2 mr-[20px]"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "image"
};
const _hoisted_7 = {
  class: "inner"
};
const _hoisted_8 = {
  class: "info"
};
const _hoisted_9 = {
  class: "info-title"
};
const _hoisted_10 = {
  class: "info-text"
};
const _hoisted_11 = {
  class: "btn"
};
import KnowledgeEditDialog from './KnowledgeForm.vue';
import { computed, onMounted, ref } from "vue";
import { Search } from "@element-plus/icons-vue";
import { useRouter } from "vue-router";
import { useSharedStore } from "@/store/sharedata";
import ItemList from "./ItemList.vue";
import { KnowledgeApi } from '@/api/ai/knowledge/knowledge';
import { useMessage } from '@/hooks/web/useMessage';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const message = useMessage(); // 消息弹窗
    const listBoxHeight = window.innerHeight - 133;
    const list = ref([]);
    const store = useSharedStore();
    const showMy = ref(false);
    const userId = ref();
    const searchKey = ref("");
    const apps = computed(() => {
      return list.value.filter(item => {
        let flag = true;
        if (showMy.value) {
          flag = item.creator === userId.value;
          if (searchKey.value) {
            flag = item.name.includes(searchKey.value);
          }
        } else {
          if (searchKey.value) {
            flag = item.name.includes(searchKey.value);
          }
        }
        return flag;
      });
    });
    onMounted(() => {
      loadKnowledgeList();
    });
    const loadKnowledgeList = async () => {
      list.value = await KnowledgeApi.getMySimpleKnowledgeList();
    };
    const router = useRouter();
    const configKnowledge = knowledge => {
      // 2. 跳转页面
      router.push({
        name: 'knowledge-config',
        query: {
          knowledgeId: knowledge.id
        }
      });
      // router.push(`/aip/knowledge/knowledge/config?knowledge_id=${knowledge.id}`);
    };
    const handleDelete = async knowledge => {
      await message.confirm(`是否删除该记录?`);
      await KnowledgeApi.deleteKnowledge(knowledge.id);
      await loadKnowledgeList();
      message.success('删除成功!');
      return;
    };
    /** 添加/修改操作 */
    const formRef = ref();
    const handlerAddRole = async () => {
      formRef.value.open('create', null, '添加知识库');
    };
    /** 编辑角色 */
    const handlerCardEdit = async knowledge => {
      formRef.value.open('update', knowledge.id, '编辑知识库');
    };
    /** 添加角色成功 */
    const handlerAddRoleSuccess = async e => {
      // 刷新数据
      await loadKnowledgeList();
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_divider = _resolveComponent("el-divider");
      const _component_Icon = _resolveComponent("Icon");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createElementVNode("ul", _hoisted_3, [_createElementVNode("li", {
        onClick: _cache[0] || (_cache[0] = $event => loadKnowledgeList())
      }, "知识库")])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_input, {
        modelValue: searchKey.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => searchKey.value = $event),
        size: "small",
        style: {
          "width": "240px"
        },
        placeholder: "搜索",
        "prefix-icon": _unref(Search)
      }, null, 8, ["modelValue", "prefix-icon"])])]), _createVNode(_component_el_divider, {
        class: "!mt-[0px]"
      }), _createElementVNode("div", {
        class: "app-list-container",
        style: _normalizeStyle({
          height: listBoxHeight + 'px'
        })
      }, [_createVNode(ItemList, {
        items: apps.value,
        gap: 15,
        width: 300,
        onAdd: handlerAddRole
      }, {
        default: _withCtx(scope => [_createElementVNode("div", {
          class: "item cursor-pointer",
          onClick: $event => configKnowledge(scope.item)
        }, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_Icon, {
          icon: "fluent:document-folder-32-regular",
          class: "mr-5px",
          size: 28
        })]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(scope.item.name), 1), _createElementVNode("div", _hoisted_10, _toDisplayString(scope.item.description), 1)]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_button, {
          type: "info",
          size: "small",
          onClick: _withModifiers($event => handleDelete(scope.item), ["stop"])
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("删除")])),
          _: 2
        }, 1032, ["onClick"]), userId.value === scope.item.creator ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          size: "small",
          onClick: _withModifiers($event => handlerCardEdit(scope.item), ["stop"])
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("编辑")])),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true)])])], 8, _hoisted_5)]),
        _: 1
      }, 8, ["items"])], 4)]), _createVNode(KnowledgeEditDialog, {
        ref_key: "formRef",
        ref: formRef,
        onSuccess: handlerAddRoleSuccess
      }, null, 512)]);
    };
  }
});